import { FC } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { Tabs, type Tab } from "shared/components/BaseTabs";

export type IdentityVerificationReportVersion = {
  id: number;
  archived_at?: string | null;
};

interface ReportVersionTabsProps {
  versions?: IdentityVerificationReportVersion[];
  selectedVersionId?: number;
  onSelectVersion: (versionId: number) => void;
}

/**
 * Identity verification reports can be re-run any number of times; each re-run
 * archives the previous report instead of replacing it. Newest first, so the tab
 * numbering counts down.
 */
export const ReportVersionTabs: FC<ReportVersionTabsProps> = ({
  versions,
  selectedVersionId,
  onSelectVersion
}) => {
  if (!versions || versions.length < 2 || !selectedVersionId) return null;

  const tabs: Tab<number>[] = versions.map((version, index) => ({
    value: version.id,
    label: (
      <span className="flex items-center gap-2">
        Report {versions.length - index}
        <Badge
          className="flex items-center capitalize"
          size={BadgeSize.SM}
          variant={
            version.archived_at ? BadgeVariant.BASE : BadgeVariant.SUCCESS
          }
        >
          {version.archived_at ? "Archive" : "Active"}
        </Badge>
      </span>
    )
  }));

  return (
    <div className="no-print -mt-2 mb-8 border-b-1 max-w-[90vw] md:max-w-[80vw] lg:max-w-[min(60vw,900px)]">
      <Tabs
        tabs={tabs}
        active={selectedVersionId}
        onChange={onSelectVersion}
        size="sm"
        tabStyle="line"
      />
    </div>
  );
};
